/**
 * REA 0.1 - observaciones de acceso público a la edición digital e-DRAE 1884.
 * Son datos de referencia para que el Creador ejecute Analyze; no es una
 * extracción de código, inspección binaria ni integración automática.
 */
export const REA_OMNI_WIKI_REFERENCE_NAME = "e-DRAE 1884 — referencia pública (UAB)";
export const REA_OMNI_WIKI_GOAL =
  "Mejorar OMNI WIKI con búsquedas históricas por lemas, etimologías, texto y comentarios filológicos, comparar fuentes, conservar citas verificables y no inventar definiciones. Implementación original OMNISYNIA.";
export const REA_OMNI_WIKI_OBSERVATIONS = [
  "Pantalla: e-DRAE 1884 — controles observados",
  "input | Término de búsqueda | Introducir lema en el formulario de la edición crítica | observed",
  "tab | Buscar lemas | Abrir el formulario de lemas de e-DRAE 1884 | observed",
  "tab | Etimología | Abrir el formulario de etimologías de la edición | observed",
  "tab | Texto completo | Abrir el formulario de búsqueda en texto de la edición | observed",
  "tab | Comentarios | Abrir el formulario de comentarios filológicos | observed",
  "Pantalla: OMNI WIKI — diseño original",
  "input | Palabra histórica | Escribir término en OMNI WIKI sin cargar un texto ajeno | documentation",
  "button | Copiar término | Copiar palabra para pegarla en el buscador de la fuente | documentation",
  "button | Comparar español actual | Consultar lema en el sitio público del DLE actual, etiquetado por edición | documentation",
  "button | Marcador local | Guardar palabra localmente sin confundirla con definición comprobada | hypothesis",
  "button | Referencia bibliográfica | Copiar referencia documentada de la edición de 1884 | documentation",
  "Pantalla: Enciclopedia — ONE CORE",
  "input | Consulta Wikipedia | Introducir pregunta enciclopédica | documentation",
  "button | Consulta verificable | Enviar la solicitud explícita al conector OMNI WIKI de ONE CORE | documentation",
  "text | Proveniencia de la fuente | Mostrar origen offline o online y fallo de conexión cuando proceda | documentation"
].join("\n");
